import React, { useEffect, useRef,useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RazorpayPayment from './RazorpayPayment';
import './AppointmentConfirm.css';

// Simple UI Components (same as in Appointment.js)
const Card = ({ children, className = "" }) => <div className={`card ${className}`}>{children}</div>;
const CardHeader = ({ children }) => <div className="card-header">{children}</div>;
const CardTitle = ({ children, className = "" }) => <h3 className={`card-title ${className}`}>{children}</h3>;
const CardContent = ({ children, className = "" }) => <div className={`card-content ${className}`}>{children}</div>;
const Badge = ({ children, className = "" }) => <span className={`badge ${className}`}>{children}</span>;

// Enhanced icons
const Icons = {
  Calendar: () => <span className="icon-bounce">📅</span>,
  Clock: () => <span className="icon-pulse">🕐</span>,
  User: () => <span className="icon-bounce">👤</span>,
  CreditCard: () => <span className="icon-bounce">💳</span>,
  CheckCircle: () => <span className="icon-success">✅</span>,
  Heart: () => <span className="icon-heartbeat">❤️</span>,
  Sparkles: () => <span className="icon-sparkle">✨</span>,
};

function AppointmentConfirm() {
  const location = useLocation();
  const navigate = useNavigate();
  const logoRef = useRef(null);
 const [paymentStatus, setPaymentStatus] = useState(null);
  // Extract appointment details from location state
  const { appId, userId, activityAmount, docName, activityName, selectedTimeSlot } = location.state || {};
  
  // Show toast notifications for different events
  useEffect(() => {
    if (location.state) {
      // Toast can be added here if needed
    }
  }, [location.state]);

  // Handle redirection logic
  useEffect(() => {
    if (!location.state) {
      toast.error('Invalid access. Redirecting to home.', {
        position: "top-right",
        autoClose: 2000,
        onClose: () => navigate('/')
      });
    }
  }, [location.state, navigate]);

  // Handle logo hover animation
  const handleLogoHover = () => {
    if (logoRef.current) {
      logoRef.current.style.transition = 'transform 0.5s ease-in-out';
      logoRef.current.style.transform = 'rotate(360deg)';
    }
  };

  const handleLogoMouseOut = () => {
    if (logoRef.current) {
      logoRef.current.style.transition = 'transform 0.5s ease-in-out';
      logoRef.current.style.transform = 'rotate(0deg)';
    }
  };

  // If no state is passed, this part won't render since we're navigating away
  if (!location.state) {
    return <div>Redirecting...</div>;
  }

  return (
    <div className="appointment-confirmation">
      <ToastContainer />
      <div className="container">
        <div className="header">
          <div className="brand-logo">
            <img 
              ref={logoRef}
              src="./hlogo.png" 
              alt="HealTrail Logo" 
              className="logo-img"
              onMouseEnter={handleLogoHover}
              onMouseOut={handleLogoMouseOut}
            />
          </div>
          <div>
            <h1>Appointments by HealTrail</h1>
            <p style={{color:"#fbfafaff"}}>Your Health Journey Starts Here</p>
          </div>
        </div>

        <div className="progress-steps">
          {[
            { step: 1, icon: Icons.User, label: "Doctor" },
            { step: 2, icon: Icons.Calendar, label: "Date" },
            { step: 3, icon: Icons.Clock, label: "Time" },
            { step: 4, icon: Icons.CheckCircle, label: "Confirm" },
          ].map(({ step, icon: Icon, label }) => (
            <div key={step} className="progress-step">
              <div className="step-icon ">
                <Icon />
              </div>
              <span className="step-label ">{label}</span>
            </div>
          ))}
        </div>

        <div className="confirmation-content">
          <Card className="confirmation-card">
            <CardHeader>
              <CardTitle>
                <Icons.CheckCircle /> Appointment Confirmed
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="confirmation-details-grid">
                {(paymentStatus?.status === 'success' || activityAmount <= 0) && (
    <div className="detail-item">
      <span>Appointment ID</span>
      <p>{appId}</p>
    </div>
  )}
                <div className="detail-item">
                  <span>Doctor Name</span>
                  <p>{docName || 'Not Specified'}</p>
                </div>
                <div className="detail-item">
                  <span>Service</span>
                  <p>{activityName || 'Consultation'}</p>
                </div>
                <div className="detail-item">
                  <span>Time Slot</span>
                  <p>{selectedTimeSlot.slotFrom} - {selectedTimeSlot.slotTo}</p>
                </div>
                {activityAmount > 0 && (
                  <div className="detail-item">
                    <span>Amount</span>
                    <p className="fee">₹{activityAmount}</p>
                  </div>
                )}
              </div>

              {activityAmount > 0 && (
                <div className="payment-section">
                  <RazorpayPayment 
                    appId={appId} 
                    userId={userId} 
                    amount={activityAmount * 100} 
                    currency="INR" 
                    onPaymentStatusChange={setPaymentStatus} 
                  />
                </div>
              )}

              <div className="confirmation-footer">
                {(paymentStatus?.status === 'success' || activityAmount <= 0) && (
                <p>Your appointment has been successfully scheduled. You will receive a confirmation message shortly.</p>)}
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="footer">
          <p style={{color:"#fbfafaff"}}>Powered By <a href="https://www.healtrail.com/" target="_blank" rel="noreferrer">HealTrail</a></p>
        </div>
      </div>
    </div>
  );
}

export default AppointmentConfirm;